import { SideNavLink } from "@/libraries/design/components";

export interface UniformSideNavLinkProps {
    type: "link";
    text: string;
    href: string;
}

const UniformSideNavLink = (props: UniformSideNavLinkProps) => {
    return <SideNavLink {...props} />;
};

export default UniformSideNavLink;
